import { Button } from "@/shared/components/Button";
import { Container } from "@/shared/components/Container";
import { Footer } from "@/shared/components/Footer";
import { GradientHeading } from "@/shared/components/GradientHeading";
import { Header } from "@/shared/components/Header";
import { SectionTag } from "@/shared/components/SectionTag";
import { useLocale } from "@/shared/i18n/locale";
import styles from "./NotFoundPage.module.css";

export function NotFoundPage() {
  const locale = useLocale();
  const isEn = locale === "en";

  return (
    <>
      <Header variant="light" compact />
      <main className={styles.page}>
        <Container>
          <section className={styles.content}>
            <SectionTag>{isEn ? "Error 404" : "Erro 404"}</SectionTag>
            <GradientHeading as="h1" className={styles.code}>
              404
            </GradientHeading>
            <h2 className={styles.title}>{isEn ? "Page not found" : "Página não encontrada"}</h2>
            <p className={styles.subtitle}>
              {isEn
                ? "The address you were looking for does not exist or has been moved. Return to the home page and continue browsing."
                : "O endereço que você procurou não existe ou foi movido. Volte para a página inicial e continue navegando."}
            </p>
            <Button href={isEn ? "/en" : "/"} variant="primary">
              {isEn ? "Back to home" : "Voltar para a home"}
            </Button>
          </section>
        </Container>
      </main>
      <Footer />
    </>
  );
}
